var EHDI = EHDI || Object.create(null);

EHDI.component = EHDI.component || Object.create(null);

EHDI.component.BackgroundScrollManager = function() {
    EHDI.aka.Container.call(this);
    
    var _this = this,
        _scrollPos = 0;
    
    this.scroll = function(curScroll) {
        var offset = curScroll - _scrollPos;
        if(offset === 0)
            return;
        for(var i = 0; i < _this.children.length; i++) {
            var obj = this.children[i];
            obj.position.y += offset;
            
            if(obj.visible && _this.position.y + obj.position.y + obj.height <= -EHDI.screen.stageHeight * 0.6 || _this.position.y + obj.position.y - obj.height >= EHDI.screen.stageWidth * 0.6) {
                obj.visible = false;
            } else if(!obj.visible && _this.position.y + obj.position.y + obj.height >= -EHDI.screen.stageHeight * 0.6 && _this.position.y + obj.position.y - obj.height <= EHDI.screen.stageHeight * 0.6) {
                obj.visible = true;
            }
        }
        _scrollPos = curScroll;
    }
    
    this.showAllChildren = function(){
        for(var i = 0; i < _this.children.length; i++) {
            var obj = this.children[i];
            obj.visible = true;
        }
    }
}

EHDI.component.BackgroundScrollManager.prototype = Object.create(EHDI.aka.Container.prototype);